import { getProvider } from '../svpProvider';
import { getLogger } from '../logger';

import { requestAPI, isSuccessResponse } from './shared/requestAPI';

const logger = getLogger('imagesApi');

async function uploadImage(image: File): Promise<string> {
  const formData = new FormData();

  formData.append('image', image);

  try {
    const result = await requestAPI<{ url: string }>(
      `/${getProvider()}/images`,
      {
        method: 'POST',
        body: formData,
      }
    );
    if (isSuccessResponse(result)) {
      return result!.url;
    }
    throw result;
  } catch (error) {
    logger.error('Failed to upload image', {
      size: `${Math.round(image.size / 1000)}kB`,
      type: image.type,
    });
    throw error;
  }
}

export { uploadImage };
